module.exports = __webpack_public_path__ + "img/dream1.4c36d466.png";